import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { Router } from '@angular/router'

import { Subscription } from 'rxjs'
import { TouaregControlDisplayService } from '../../services/touareg-control-display.service'
import { TouaregControlStateParamsService } from '../../services/touareg-control-state-params.service'
import { TouaregControlHealthComponent } from '../touareg-control-health/touareg-control-health.component';
import { Samv2Module } from '@aubert-et-duval/samv2';
import { TouaregControlStatesComponent } from '../touareg-control-states/touareg-control-states.component';

@Component({
  selector: 'app-touareg-control',
  templateUrl: './touareg-control.component.html',
  styleUrls: ['./touareg-control.component.scss'],
  imports: [TouaregControlHealthComponent, Samv2Module, TouaregControlStatesComponent],
})
export class TouaregControlComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<MouseEvent>()

  private _touaregStatesParamsSubs$!: Subscription
  public actualDisplay!: string

  public connected!: boolean

  constructor(
    public _router: Router,
    public _params: TouaregControlStateParamsService,
    public displayService: TouaregControlDisplayService
  ) {}

  ngOnInit(): void {
    this.displayService.display$.subscribe((display) => {
      this.actualDisplay = display.currentState
    })

    this._touaregStatesParamsSubs$ = this._params.params$.subscribe(
      (params) => {
        const { connect, beaconId } = params || {}
        if (!connect || !beaconId) {
          this.connected = false
          // this.displayService.settingsOn()
        } else {
          this.connected = true
          // this.displayService.settingsOff()
        }
      }
    )
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (!!this._touaregStatesParamsSubs$)
      this._touaregStatesParamsSubs$.unsubscribe()
  }
}
